module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAKCAYAAAC9vt6cAAAAAXNSR0IArs4c6QAAAMVJREFUKBVjVFRUnPn///80BjIAIyPjLCYuLq5coN7jZOg/DtLLCNKoqakp+f3797NApiSRBj3n5OQ0vn79+nOwASBNKioqln///j0A9A4bPkOAzv7FzMzscOfOHbCrmWGK371790RQUPAVkO8LE8NGAw3Iunfv3kaYHNwAkMCHDx/OAg2RAjKNYQqQaVCg3b9/vxFZjAmZA2LjCVRwoKGrh4cBsgSWQIUHGrI6EBurASAJWKCC2MiBBuITDYCJLA2E8WkAAIfGQo4kU7ZoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/triangle@2x.png
// module id = 354
// module chunks = 0